import React, { useState } from 'react';
import {
  StandingsContainer,
  StandingsHeader,
  StandingsTitle,
  ManagePointsButton,
} from '../NormalDetails.styles';
import Game from '../../../_types/Game';
import GamesTable from './GamesTable';
import { GamifyToast } from '../../../../../common/CustomToasts';

interface Props {
  game: Game;
  gamesTableData: any[];
  refetchData?: () => void;
}

const Standings = ({ game, gamesTableData, refetchData }: Props) => {
  const [managePoints, setManagePoints] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const isIncentiveGame = game.contestType === 'incentive';

  const hasTeamStructure = gamesTableData?.some(
    (item) => item.users && item.users.length > 0
  );
  const isCircleGame =
    game.type === 'circle' || game.scope === 'circle' || hasTeamStructure;

  const handleCloseAndRefetch = async (toastConfig: any) => {
    if (toastConfig.type === 'success') {
      GamifyToast.success(toastConfig.text1);

      setIsRefetching(true);

      if (refetchData) {
        try {
          await refetchData();
        } catch (error) {
          console.error('Error refetching data in Standings:', error);
          GamifyToast.error(
            'Could not refresh data. Please try reloading the page.'
          );
        } finally {
          setIsRefetching(false);
        }
      } else {
        setIsRefetching(false);
      }
    } else {
      GamifyToast.error(toastConfig.text1);
    }
    setManagePoints(false);
  };

  return (
    <StandingsContainer>
      <StandingsHeader>
        <StandingsTitle>Standing</StandingsTitle>
        {window.me?.isAdmin && (
          <ManagePointsButton
            onClick={() => {
              if (managePoints) {
                setManagePoints(false);
              } else {
                setManagePoints(true);
              }
            }}
          >
            {managePoints ? 'Cancel' : 'Manage points'}
          </ManagePointsButton>
        )}
      </StandingsHeader>

      <GamesTable
        isIncentiveGame={isIncentiveGame}
        data={gamesTableData}
        managePoints={managePoints}
        gameDimension={isCircleGame ? 'circle' : game.type}
        closeAndRefetch={handleCloseAndRefetch}
        isRefetching={isRefetching}
      />
    </StandingsContainer>
  );
};

export default Standings;
